import { Collapsible as CollapsiblePrimitive } from '@base-ui/react/collapsible';

import { cn } from '../lib/utils';

function Collapsible({ ...props }: Readonly<CollapsiblePrimitive.Root.Props>) {
  return <CollapsiblePrimitive.Root data-slot="collapsible" {...props} />;
}

function CollapsibleTrigger({ ...props }: Readonly<CollapsiblePrimitive.Trigger.Props>) {
  return <CollapsiblePrimitive.Trigger data-slot="collapsible-trigger" {...props} />;
}

function CollapsibleContent({ className, ...props }: Readonly<CollapsiblePrimitive.Panel.Props>) {
  return (
    <CollapsiblePrimitive.Panel
      data-slot="collapsible-content"
      // `panel-collapse`: anima a altura de/para 0 usando `--collapsible-panel-height`, que o
      // Base UI publica no painel. Sem isto o disclosure entra e sai seco — ver a nota
      // da utilitária em `../styles.css`.
      className={cn('panel-collapse', className)}
      {...props}
    />
  );
}

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
